import { BpeService } from "../../bpe/bpe.service";
import { EventData } from "../../../services/event.service";

export async function runEventDetailsInlineEditScenarios<T>(
    eventId: number,
    change: () => Promise<T>,
    silent?: boolean,
): Promise<T> {
    if (silent) return change();
    return BpeService.runScenarios({
        eventId,
        getSources: () => ["event-details-inline-edit"],
        change,
    });
}

/** Run event-details-inline-edit scenarios for changes already saved during silent save. */
export async function runDeferredEventDetailsInlineEditScenarios(
    eventId: number,
    preEventData: EventData,
): Promise<EventData | undefined> {
    let postEventData: EventData | undefined;
    await BpeService.runScenarios({
        eventId,
        getSources: () => ["event-details-inline-edit"],
        preEventData,
        change: () => Promise.resolve(),
        awaitScenarioCompletion: true,
        onScenarioPostData: (post) => (postEventData = post),
    });
    return postEventData;
}
